/**
 * @desc 根据用户编码获取视图
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  Array<defs.appCenter.PageViewAggregationResponseDto>
>;
export function request(
  params: API.appCenter.view.getViewByUserCode.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/view/user/tree`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
